
import React from 'react';
import Layout from '@/components/layout/Layout';
import { UserManagementPanel } from '@/components/users/UserManagementPanel';

const Users: React.FC = () => {
  return (
    <Layout>
      <UserManagementPanel />
    </Layout>
  );
};

export default Users;
